export default "__VITE_ASSET__BgDL8UKD__"